export function scrollToTopAsync() {
  return new Promise<void>((resolve) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Check if scrolling is already at the top
    if (window.scrollY === 0) {
      resolve();
      return;
    }

    // in case if we have some troubles with scroll, resolve anyway after 5 seconds
    const resolveTimeout = setTimeout(() => {
      window.removeEventListener('scroll', onScroll);
      resolve();
    }, 5000);

    function onScroll() {
      if (window.scrollY === 0) {
        window.removeEventListener('scroll', onScroll);
        clearTimeout(resolveTimeout);
        resolve();
      }
    }

    window.addEventListener('scroll', onScroll);
  });
}
